import React from 'react';
import _ from 'lodash';
import moment from 'moment';

import component, {classnames} from '../component';
import {HBox, VBox} from '../Box';
import HtmlContent from '../HtmlContent';
import Link from '../Link';
import {ArrowRight} from '../icons';
import tournamentStatuses from '../tournamentStatuses';
import emptyPic from './../emptyPic';

import TournamentDetails, {displayDateRange, displayDateRangeTitle} from './TournamentDetails';

export default component('TournamentRules', function({data, params}) {
  const tourney = data.cursor(['tournamentData', parseInt(params.id, 10)]);
  const finished = tourney.get('status') === tournamentStatuses.finished.id;
  const TournamentRules = (
    <div className='TournamentRules'>
      <div className='TournamentRules-Description'>
        <h1>Правила турнира</h1>
      </div>
      <HBox width={4}>
        <VBox width={1}>
          <div className='TournamentRules-Data'>
            {tourney.get('logo') &&
              <img src={tourney.get('logo') ? `${tourney.get('logo')}?w=208` : emptyPic} className='TournamentRules-DataLogo' />
            }
            {tourney.getIn(['dates', 'from']) && tourney.getIn(['dates', 'to']) &&
              <div>
                <div className='TournamentRules-DataTitle'>
                  {displayDateRangeTitle(tourney.get('dates'), 'Дата', 'Период')} проведения
                </div>
                <div className='TournamentRules-DataValue'>
                  {displayDateRange(tourney.get('dates'), finished)}
                </div>
              </div> || ''
            }
            {tourney.getIn(['registration_dates', 'from']) && tourney.getIn(['registration_dates', 'to']) &&
              <div>
                <div className='TournamentRules-DataTitle'>
                  {displayDateRangeTitle(tourney.get('registration_dates'), 'Дата', 'Период')} регистрации
                </div>
                <div className='TournamentRules-DataValue'>
                  {displayDateRange(tourney.get('registration_dates'), finished)}
                </div>
              </div> || ''
            }
            {tourney.getIn(['confirmation_dates', 'from']) && tourney.getIn(['confirmation_dates', 'to']) &&
              <div>
                <div className='TournamentRules-DataTitle'>
                  {displayDateRangeTitle(tourney.get('confirmation_dates'), 'Дата', 'Период')} подтверждения
                </div>
                <div className='TournamentRules-DataValue'>
                  {displayDateRange(tourney.get('confirmation_dates'), finished)}
                </div>
              </div> || ''
            }
            <div className='TournamentRules-DataTitle'>Статус</div>
            <div className='TournamentRules-DataValue'>
              {_.find(tournamentStatuses, ts => ts.id === tourney.get('status')).name}
            </div>
          </div>
        </VBox>
        <VBox width={2}>
          <div className='TournamentRules-Content'>
            <HtmlContent html={tourney.get('rules')}/>
          </div>
        </VBox>
        <VBox width={1}></VBox>
      </HBox>
    </div>
  );

  return <TournamentDetails content={TournamentRules} data={data} params={params} />;
});



// WEBPACK FOOTER //
// ./src/components/pages/TournamentRules.js